import {
  OtherGroundProductsThanCementClassificationInputNames,
  MaterialType
} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {LONG_COLUMN_WIDTH} from '@settings/modules/common/consts'

const fields = [
  {key: OtherGroundProductsThanCementClassificationInputNames.Category},
  {
    key: OtherGroundProductsThanCementClassificationInputNames.IntermediateMillProduct,
    minWidth: LONG_COLUMN_WIDTH
  },
  {
    key: OtherGroundProductsThanCementClassificationInputNames.ReferenceMeshSizeForResidue,
    minWidth: LONG_COLUMN_WIDTH
  }
]

export const OtherGroundProductsThanCementClassificationHeader = () => {
  return (
    <ClassificationHeaderCells
      fields={fields}
      materialType={MaterialType.OtherGroundProductsThanCement}
    />
  )
}
